$(document).ready(function () {
    $(document).on('nc.sidePanel.shown', function (e, result) {
        if (window.sidePanels.getCurrentSidePanel() !== undefined) {
            const containers = document.querySelectorAll('#upload-with-file-preview');
            if (containers.length) {
                const previewDivs = document.querySelectorAll('#process-file-preview-div');
                const pdfEmbeds = document.querySelectorAll('#process-file-pdf-preview');

                containers.forEach((container, index) => {
                    const previewDiv = previewDivs[index] || null;
                    const pdfEmbed = pdfEmbeds[index] || null;
                    initialize(container, previewDiv, pdfEmbed);
                });
            }
        } else {
            console.log('upload-with-file-preview: Error getting side-panel');
        }
    });

    // Helper: hide all file preview panes and reset toggles
    function hideAllFilePreviews() {
        document.querySelectorAll('#process-file-preview-div').forEach(div => div.classList.add('d-none'));
        document.querySelectorAll('#process-file-open-preview').forEach(btn => {
            btn.setAttribute('data-opened', 'false');
            btn.innerHTML = '<i class="fas fa-eye"></i>';
        });
    }

    // Hide all file previews when the type is changed (native change)
    $(document).on('change', 'select[name="type"]', function () {
        hideAllFilePreviews();
    });

    // Also handle Bootstrap-Select change event
    $(document).on('changed.bs.select', 'select[name="type"]', function () {
        hideAllFilePreviews();
    });

    function initialize(container, previewDiv, pdfEmbed) {
        const id = 'process-file';

        const openBtn = container.querySelector('#' + id + '-open-preview');
        const deleteBtn = container.querySelector('#' + id + '-delete-file');
        const fileInput = container.querySelector('#' + id + '-files');

        if (!openBtn || !deleteBtn || !fileInput || !previewDiv || !pdfEmbed) {
            return;
        }

        openBtn.addEventListener('click', function () {
            let isOpen = openBtn.getAttribute('data-opened');
            if (isOpen === 'false') {
                showPreviewPane(openBtn, previewDiv);
            } else {
                hidePreviewPane(openBtn, previewDiv);
            }
        });

        deleteBtn.addEventListener('click', function () {
            pdfEmbed.src = '';
            disableDeleteAndPreviewButton(deleteBtn, openBtn);
            fileInput.value = '';
            if (fileInput.nextElementSibling) {
                fileInput.nextElementSibling.innerHTML = 'Selecteer bestand(en)';
            }
            hidePreviewPane(openBtn, previewDiv);
        });

        fileInput.addEventListener('change', function () {
            const files = this.files;
            if (!files || !files.length) {
                disableDeleteAndPreviewButton(deleteBtn, openBtn);
                return;
            }
            if (files[0].type !== 'application/pdf') {
                disableDeleteAndPreviewButton(deleteBtn, openBtn);
                hidePreviewPane(openBtn, previewDiv);
                return;
            }
            pdfEmbed.src = URL.createObjectURL(files[0]) + '#toolbar=0&navpanes=0&scrollbar=0&';
            enableDeleteAndPreviewButton(deleteBtn, openBtn);
        });
    }

    function enableDeleteAndPreviewButton(deleteBtn, openBtn) {
        deleteBtn.disabled = false;
        openBtn.disabled = false;
    }

    function disableDeleteAndPreviewButton(deleteBtn, openBtn) {
        deleteBtn.disabled = true;
        openBtn.disabled = true;
    }

    function hidePreviewPane(openBtn, previewDiv) {
        openBtn.setAttribute('data-opened', 'false');
        openBtn.innerHTML = '<i class="fas fa-eye"></i>';
        if (previewDiv) {
            previewDiv.classList.add('d-none');
        }
    }

    function showPreviewPane(openBtn, previewDiv) {
        openBtn.setAttribute('data-opened', 'true');
        openBtn.innerHTML = '<i class="fas fa-eye-slash"></i>';
        if (previewDiv) {
            previewDiv.classList.remove('d-none');
        }
    }
});
